import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IParamposList } from '../models/models'

export class ListParatikaPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'posTransaction/listParatikaInsatallment',
      requesterInfo,
    })
  }

  public async listParatikaPosInsatallment(request: number): Promise<IParamposList[]> {
    this.props.url = `${this.props.url}/?bankId=${request}`
    return await this.getAsync<IParamposList[]>()
  }

  public async listParatikaPosInsatallmentNoBank(): Promise<IParamposList[]> {
    this.props.url = `posTransaction/listParatikaInsatallmentNoBank`
    return await this.getAsync<IParamposList[]>()
  }
}
